// src/AuthContext.js
import { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth, db } from "./firebase";
import { doc, getDoc } from "firebase/firestore";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [role, setRole] = useState(null);
  const [mustChangePassword, setMustChangePassword] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        await firebaseUser.reload(); // 🟡 Refresh user info
        const freshUser = auth.currentUser;

        console.log("✅ Logged in user:", freshUser?.displayName, freshUser?.email);
        setCurrentUser(freshUser);

        // 🔍 Fetch user doc from Firestore
        const docRef = doc(db, "users", freshUser.uid);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          setRole(data.role || null);
          setMustChangePassword(!!data.mustChangePassword); // ✅ check flag
        } else {
          setRole(null);
          setMustChangePassword(false);
        }
      } else {
        setCurrentUser(null);
        setRole(null);
        setMustChangePassword(false);
      }

      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const logout = () => signOut(auth);

  return (
    <AuthContext.Provider value={{ currentUser, role, mustChangePassword, loading, logout }}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
